/// <reference path="./d/app.d.ts" />
/// <reference path="sxcframe.ts" />


interface ChatClientWrapperParams {
	chatAPI: any;
	root : JQuery;
	perfID: string;
	topup: any;
	support : any;
	userAuth : any;
	url : any;
	memberIncentive : any;
	securionPayHandler : SecurionPayChatHandler;
}

declare module Sxc.Chat {
	export class Application {
		constructor(params : any, flavour: any)
	}
}

declare module Sxc.SP {
	export class SecurionPay {
		constructor(params : any, flavour: any)
	}
}

class ChatClientWrapper
{
	private TAG = "[ChatClientWrapper]";

	private frame : Sxc.WindowManager.Frame;
	private $root : JQuery;
	public app : any;

	private memberIncentive: any;

	constructor(private params : ChatClientWrapperParams)
	{
		debug.log(this.TAG, "Init");

		this.initFrame();
		this.initMemberIncentive();

		params.url = {
			support: "/contact",
			terms: "/terms",
			privacy: "/privacy",
		};

		let t = this;

		params.support = () => {
			let url = "/contact";
			window.open(url, '_blank');
		};

		this.initSecurionPay();
		this.initAuth();

		this.app = new window["SxcChatApplication"](params, {lite: false, flavour: "full", fakeStream: ""});

		this.initFramePaging();

		this.app.event.on("backdrop-visible", (visibility) =>
		{
			debug.log("chatvisible event", visibility);
			this.frame[visibility ? "show" : "fauxHide"]();
			$("html").css({"overflow": visibility ? "hidden" : ""});
			if (window["roomList"] && window["roomList"].listParams && window["roomList"].autoUpdate) {
				window["roomList"].update();
			}
		});

		this.app.event.on("sizeChanged", (w, h, left, top) =>
		{
			if (!this.memberIncentive) return;
			this.memberIncentive.setTopupIconPos(left, top)
		});

		this.initChatLinkHandler();

		//if in iframe
		if(window.top!=window){
			var style = document.createElement('style');
			style.innerHTML = 'body.chat .frame-content{overflow:hidden !important;height:600px;}';
			document.getElementsByTagName('head')[0].appendChild(style);
		}
	}

	public join(roomID, screenName, profilePic, special)
	{
		this.app.showRoom(roomID, screenName, profilePic, special);
	}

	private initFrame()
	{
		this.frame = new Sxc.WindowManager.Frame("chat-app", false);
		let template = "<div class=\"chat-app-root\"></div>\n<div class=\'frame-paging\'>\n\t<div class=\'nav prev\'>\n\t\t<div class=\'nav-inner\'>\n\t\t\t<div class=\'video\'><img src=\'\' alt=\'\'><div class=\'stream\'></div></div>\n\t\t\t<div class=\'name\'>Name of perf</div>\n\t\t</div>\n\t</div>\n\t<div class=\'nav next\'>\n\t\t<div class=\'nav-inner\'>\n\t\t\t<div class=\'video\'><img src=\'\' alt=\'\'><div class=\'stream\'></div></div>\n\t\t\t<div class=\'name\'>Name of perf</div>\n\t\t</div>\n\t</div>\n</div>";
		this.$root = $(template);
		this.frame.setContent(this.$root);

		this.params.root = this.$root.filter(".chat-app-root");
	}

	private initMemberIncentive()
	{
		const t = this;

		if ("MemberIncentive" in window)
		{
			// @ts-ignore
			this.memberIncentive = new window["MemberIncentive"]();

			this.params.memberIncentive =
				{
					check(perfID, onReady)
					{
						debug.log("memberincentive check", perfID);
						let form = {
							perfID: perfID,
							action: "canWatch"
						};

						let onReqReady = (r) => onReady(r);
						let onReqFailed = () => onReady(null);

						$.post('/ajax/chat/memberincentive', form, onReqReady, 'json')
							.error(onReqFailed);
					},

					trigger(roomID : string, level : string, screenName, onReady)
					{
						debug.log("memberincentive trigger", roomID, level, screenName) ;

						let onTopup;

						if (level === "warn") {
							onTopup = () => t.app.showTopup();
						} else {
							onTopup = () => topupHandler.show("", "creditcard", null);
						}

						this.memberIncentive.show(level, screenName, onTopup, onReady);
					},

					setWatched(roomID : string)
					{
						let form = {
							perfID: roomID,
							action: "setWatched"
						};

						$.post('/ajax/chat/memberincentive', form, () => {}, 'json');
					}
				};
		}
	}

	private initSecurionPay()
	{
		if (window["securionPayHandler"])
		{
			this.params.securionPayHandler =
				{
					register(eventHandler : SecurionPayChatEventHandler) : void
					{
						// methods in event handler:
						// updatePushPromo(promo)
						// showNotification(message)

						window["securionPayHandler"].eventHandler = eventHandler;
						//window["securionPayHandler"].panel.setEnabled(false);
						eventHandler.setCurrentPromo(window["securionPayHandler"].promo.promo);
					},

					unRegister() : void
					{
						window["securionPayHandler"].eventHandler = null;
						window["securionPayHandler"].panel.setEnabled(true);
					},

					doQuickBuy(amount : number, special : any, onReady : (success : boolean, reason : string) => void) : void
					{
						debug.log("securionPayChatHandler", "doQuickBuy", amount);
						window["securionPayHandler"].quickbuy.buy(amount, null, special, onReady);
					},
					showAltPaymentButtonOnInit() : void
					{
						debug.log("securionPayChatHandler", "showAltPaymentButtonOnInit");
						window["securionPayHandler"].creditcard.showAltPaymentButtonOnInit();
					},

					doPurchase(amount : number,
					           name : string,
					           email : string,
					           card : string,
					           expYear : string,
					           expMonth : string,
					           cvc : string,
					           store : boolean,
					           autoPay : boolean,
					           onReady : (success : boolean, data : any) => void) : void
					{
						// Prepare shadow form

						debug.log("securionPayChatHandler", "doPurchase", amount, name, email, card, expYear, expMonth, cvc, store, autoPay);

						let $form = $("<form />");

						let addInput = (name, value) => {
							$form.append($("<input type='hidden' />").attr("name", name).attr("value", value));
						};

						let addInputC = (name, value) => {
							$form.append($("<input type='checkbox' />").attr("name", name).attr("value", "1").prop("checked", value));
						};

						let addInputD = (name, value = null) => {
							let $i = $("<input type='hidden' />").attr("data-securionpay", name);
							if (value) $i.val(value);
							$form.append($i);
						};

						// Our data (emulating the legacy sp panel
						addInput("name", name);
						addInput("email", email);
						addInput("number", card);
						addInput("credits", amount);
						addInput("exp-year", expYear);
						addInput("exp-month", expMonth);
						addInput("cvc", cvc);
						addInputC("store_card", store);
						addInputC("enable_autobuy", autoPay);

						// The sp lib will use these inputs
						addInputD("number");
						addInputD("expYear");
						addInputD("expMonth");
						addInputD("amount");
						addInputD("cvc", cvc);
						addInputD("currency");

						window["securionPayHandler"].creditcard.submit(null, $form, (success : boolean, data : any) => {
							onReady(success, data);
							$form.remove();
						});
					}
				};
		}
		else
		{
			this.params.securionPayHandler = null;

			window["echh"].on("start", promo => {
				this.app.echhStarted(promo);
			});
			window["echh"].on("end", promo => {
				this.app.echhEnded(promo);
			});
		}
	}

	private initAuth()
	{
		this.params.userAuth = {

			captchaURL : "https://sexchat.hu/lib/captcha/captcha.php?language=hu&w=150&h=37&theme=dark&",

			login(name, passwd, captcha, remember, onReady) {

				let form = {
					ajax: 1,
					action: "login",
					userid: name,
					captcha: captcha,
					rememberme: remember ? "1" : "",
					passwd: passwd,
					passwd2: passwd,
					source: "chat",
					token: $('#recaptchatoken').val()
				};

				let onReqReady = (r) => {
					debug.log("login res", r);
					onReady(r.error ? r.error : "success")
				};

				let onReqFailed = () => {
					onReady("technical");
				};

				$.post('/', form, onReqReady, 'json')
					.error(onReqFailed)
					.always(function() {
						// @ts-ignore
						reCAPTCHA_execute();
					})
				;

			},

			register(name, email, passwd, onReady) {

				let form = {
					ajax: 1,
					action: "join",
					userid: name,
					email: email,
					passwd: passwd,
					passwd2: passwd,
					source: "chat",
					token: $('#recaptchatoken_reg').val()
				};

				let onReqReady = (r) => {
					onReady(r.error ? r.error : "success")
				};

				let onReqFailed = () => {
					onReady("technical");
				};

				$.post('/', form, onReqReady, 'json')
					.error(onReqFailed);
			},

			reminder(email, onReady) {
				let form = {
					ajax: 1,
					action: "reminder",
					email: email,
				};

				let onReqReady = (r) => {
					onReady(r.error ? r.error : "success")
				};

				let onReqFailed = () => {
					onReady("technical");
				};

				$.post('/', form, onReqReady, 'json')
					.error(onReqFailed);
			}
		};

	}

	private initFramePaging()
	{
		const $framePaging = this.$root.filter(".frame-paging");

		const $prev = $framePaging.find(".nav.prev");
		const $next = $framePaging.find(".nav.next");

		let lastVisibility = true;

		let next = null;
		let nextLeaveTimer;
		let prevLeaveTimer;
		let history = [];

		let rp = null;

		this.app.event.on("backdrop-visible", (visibility) =>
		{
			console.log("chatvisible event", visibility);
			$framePaging[visibility ? "show": "hide"]();
		});

		this.app.event.on("roomHistoryChanged", (hist) =>
		{
			debug.log("roomHistoryChanged", [...hist]);
			if (hist.length > 1) {
				$framePaging.find(".nav.prev").show();
			} else {
				$framePaging.find(".nav.prev").hide();
			}

			history = hist
		});

		const fillAndStream = ($box, room) =>
		{
			console.log("ROOM", room ? room.roomMode : null, room);
			$box.find(".name").text(room.screenName);

			if (room.roomMode === "free")
			{
				rp = new window["SxcChatPreview"]($box.find(".stream")[0], {
					apiURL: this.params.chatAPI
				});

				rp.setVolume(0);

				rp.showRoom(room.roomid, (mode) =>
				{
					console.log("ROOM", mode);
					if (mode !== "free" && mode !== "end") {
						if (rp) {rp = null;}
						$box.find(".stream").empty();
						$box.find("img").show().attr("src", room.publicData.profilePic);
					}
				});
			}
			else
			{
				$box.find("img").show().attr("src", room.publicData.profilePic);
			}
		};

		const clearAndStop = ($box) => {
			if (rp) {rp = null;}
			$box.find(".stream").empty();
			$box.find("img").hide();
		};

		const getNextRoom = () => {

			const except = [];
			if (next) {
				except.push(next.roomid);
			}
			if (this.app.chatServer.currentRoom) {
				except.push(this.app.chatServer.currentRoom.getID())
			}

			let room = this.app.selectNext(except);

			if (!room) {
				let rooms = this.app.vxRoomList.getRooms();
				room = rooms[Math.floor(Math.random() * rooms.length)];
			}
			return room;
		};

		let prevEnabled = true;

		$prev.click(() => {
			if (!prevEnabled) return;
			this.app.prev();
			let id = history.length - 3;
			$prev.css("opacity", 0.8);
			if (id >= 0) {
				let prevID = history[id];
				let room = this.app.chatServer.roomList.getByID(prevID);
				fillAndStream($prev, room);
			}
			setTimeout(() => {
				prevEnabled = true;
				$prev.css("opacity", 1);
			}, 3000);
		});


		let nextEnabled = true;

		$next.click(() => {
			if (!next) return;
			if (!nextEnabled) return;
			this.app.showRoom(next.roomid);
			next = getNextRoom();
			nextEnabled = false;
			$next.css("opacity", 0.8);
			clearAndStop($next);
			fillAndStream($next, next);
			setTimeout(() => {
				nextEnabled = true;
				$next.css("opacity", 1);
			}, 3000);
		});

		$prev.on("mouseenter", () => {
			clearAndStop($prev);
			clearTimeout(prevLeaveTimer);

			let id = history.length - 2;
			if (id >= 0) {
				let prevID = history[id];
				let room = this.app.chatServer.roomList.getByID(prevID);
				fillAndStream($prev, room);
			}
		});

		$prev.on("mouseleave", () => {
			prevLeaveTimer = setTimeout(() => {
				clearAndStop($prev);
			}, 500);
		});

		$next.on("mouseenter", () => {
			console.log("NEXTENDER");
			clearAndStop($next);
			clearTimeout(nextLeaveTimer);
			next = getNextRoom();
			fillAndStream($next, next);
		});

		$next.on("mouseleave", () => {
			console.log("NEXTLEAVE");
			nextLeaveTimer = setTimeout(() => {
				clearAndStop($next)
			}, 500);
		});

		// this.app.event.on("roomStatusChange", () =>
		// {
		// 	let curr = this.app.chatServer.currentRoom;
		// 	let cnt = this.app.chatServer.roomList.roomList.filter((r) => {
		// 		return r.roomMode == "free"
		// 			&& (!curr || r.roomid != curr.roomData.roomid)
		// 	}).length;
		//
		// 	if (cnt) $next.show();
		// 	else $next.hide();
		// });

		this.app.event.on("sizeChanged", (w, h, left, top) =>
		{
			debug.log("sizeChanged", w, h);
			let wv = $(window).innerWidth();
			let wh = $(window).innerHeight();

			if (wv - 70 < w) {
				if (lastVisibility) {
					$framePaging.hide();
					lastVisibility = false;
				}
			} else {
				if (!lastVisibility) {
					$framePaging.show();
					lastVisibility = true;
				}
			}
		});
	}

	private initChatLinkHandler()
	{
		$(document).on("click", "a", (e) =>
		{
			let $link = $(e.currentTarget);
			let url = $link.attr("href");
			let m = url.match(/^\/mypage\/([^\/]+)\/[^\/]*\/chat/);

			if (m) {
				const roomID = m[1];
				e.preventDefault();
				e.stopImmediatePropagation();

				let screenName = $(e.currentTarget).data("screenname");
				let profilePic = $(e.currentTarget).data("profilepic");
				this.join(roomID, screenName, profilePic, {});
			}
		});
	}
}
